import type { Money } from '../types'

export const PERSONAL_EXPENSE_CATEGORIES = ['market', 'bills', 'rent', 'transport', 'health', 'education', 'entertainment', 'clothing', 'other_expense'] as const
export const PERSONAL_INCOME_CATEGORIES = ['salary', 'bonus', 'side', 'investment', 'other_income'] as const
export type PersonalCategory = (typeof PERSONAL_EXPENSE_CATEGORIES)[number] | (typeof PERSONAL_INCOME_CATEGORIES)[number]

export const RECURRENCES = ['once', 'monthly', 'yearly'] as const
export type Recurrence = (typeof RECURRENCES)[number]

export const WALLET_TYPES = ['cash', 'bank', 'credit_card'] as const
export type WalletType = (typeof WALLET_TYPES)[number]

/** Kişisel cüzdan; kart için yalnız son 4 hane tutulur. */
export type PersonalWallet = { id: string; name: string; type: WalletType; bankName: string; last4: string; opening: Money; balance: Money }

export type PersonalEntry = {
  id: string
  kind: 'expense' | 'income'
  category: PersonalCategory
  amount: Money
  date: string
  walletId: string
  recurrence: Recurrence
  status: 'paid' | 'pending'
  description: string
  attachmentName: string
  /** payroll: sistemin aktardığı maaş/firma ödemesi; locked ise kişi değiştiremez/silemez. */
  source: 'manual' | 'payroll'
  locked: boolean
}

/** Maaş aktarım tercihi; employeeLinked false ise hesap bir personel kaydına bağlı değildir. */
export type PersonalSettings = { autoSalary: boolean; salaryWalletId: string; syncFrom: string; employeeLinked: boolean }

export type PersonalNote = { id: string; title: string; tags: string[]; body: string; pinned: boolean; remindAt: string | null; attachmentName: string; updatedAt: string }

export type PersonalSummary = {
  month: string
  income: Money
  expense: Money
  net: Money
  pending: { count: number; amount: Money }
  byCategory: { category: PersonalCategory; amount: Money; pct: number }[]
  walletsTotal: Money
}

export type WalletInput = Omit<PersonalWallet, 'id' | 'balance'>
export type EntryInput = Omit<PersonalEntry, 'id' | 'source' | 'locked'>
export type NoteInput = Omit<PersonalNote, 'id' | 'updatedAt'>
export type SettingsInput = Omit<PersonalSettings, 'employeeLinked'>
